import { makeStyles } from 'tss-react/mui';

import { styleCondition } from '../../../../../../utils/styleCondition';

export const useStyles = makeStyles()((theme) => ({
  fieldLabel: { marginRight: 16 },
  internalRadioGroup: {
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        marginLeft: 0,
      }),
    },
  },
  radioLabel: {
    alignItems: 'center',
    marginRight: 0,
    width: 'fit-content',
    '& .MuiTypography-root': {
      fontSize: 18,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 16,
        }),
      },
    },
    '& .PrivateSwitchBase-root': {
      [theme.breakpoints.down('md')]: {
        marginTop: 2,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginTop: 2,
        }),
      },
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'start',
      '& .MuiFormControlLabel-label': {
        marginLeft: '-28px',
      },
      '&:not(:last-child)': {
        marginBottom: '14px',
      },
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        alignItems: 'start',
        '& .MuiFormControlLabel-label': {
          marginLeft: '-28px',
        },
        '&:not(:last-child)': {
          marginBottom: '10px',
        },
      }),
    },
  },
  radioItem: {
    color: '#C6CAC6',
    padding: 8,
    '&$checked': { color: theme.palette.primary1 },
    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        padding: 5,
      }),
    },
  },
  input: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 60,
    '& input': {
      textAlign: 'end',
    },
    '& #input-error': {
      fontSize: 12,
      marginTop: 0,
      position: 'absolute',
      width: 'max-content',
    },
  },
  select: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      margin: '2px 10px',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        margin: '2px 10px',
      }),
    },
    '& .MuiFormControl-root#select': {
      '& > div': {
        borderRadius: '10px !important',
        color: theme.palette.black,
        fontWeight: 400,

        '& .MuiSelect-select > span': {
          fontSize: 16,
          fontWeight: 400,
          [theme.breakpoints.down('md')]: {
            fontSize: 14,
          },
          [theme.breakpoints.downLandscape('md')]: {
            ...styleCondition(theme.isMobileDevice, {
              fontSize: 14,
            }),
          },
        },
      },
      '& fieldset': {
        border: `1px solid ${theme.palette.grey1}`,
        backgroundColor: 'initial',
      },
    },
  },
  daySelect: {
    width: 105,
    [theme.breakpoints.down('md')]: {
      width: 98,
    },
    [theme.breakpoints.downLandscape('md')]: styleCondition(
      theme.isMobileDevice,
      {
        width: 98,
      },
    ),
  },
  weekDaySelect: {
    width: 130,
    [theme.breakpoints.down('md')]: {
      width: 105,
    },
    [theme.breakpoints.downLandscape('md')]: styleCondition(
      theme.isMobileDevice,
      {
        width: 105,
      },
    ),
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 16,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
      fontSize: 14,
      letterSpacing: '0.1px',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        flexWrap: 'wrap',
        fontSize: 14,
        letterSpacing: '0.1px',
      }),
    },
  },
  margin: {
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
      }),
    },
  },
  span: {
    [theme.breakpoints.down('md')]: {
      marginLeft: 28,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        marginLeft: 28,
      }),
    },
  },
  disclaimer: {
    left: 365,
    top: -14,
    width: 530,
    [theme.breakpoints.down('lg')]: {
      top: '50%',
      transform: 'translateY(-50%)',
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      marginLeft: -6,
      position: 'initial',
      transform: 'none',
      width: 'min-content',
    },
  },
  weekDayDisclaimer: {
    left: 505,
    top: -28,
    width: 410,
    [theme.breakpoints.down('lg')]: {
      top: '50%',
      transform: 'translateY(-50%)',
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      marginLeft: -6,
      position: 'initial',
      transform: 'none',
      width: 'min-content',
    },
  },
}));
